import {
  createContext,
  useContext,
  useEffect,
  type Dispatch,
  type ReactNode,
} from "react";

import { ColorScheme, useMedia } from "@superweb/ui";

import { useLocalStorage } from "@fleet/ui";

type Theme = "light" | "dark" | "system";

const ColorSchemeContext = createContext<{
  setTheme: Dispatch<Theme>;
  theme: Theme;
}>({ theme: "system", setTheme: () => {} });

export const useColorScheme = () => useContext(ColorSchemeContext);

export const ColorSchemeProvider = ({ children }: { children?: ReactNode }) => {
  const [theme, setTheme] = useLocalStorage<Theme>(
    "db3803c7-b1eb-453a-b7f2-7618a95bda10",
    "system",
  );

  const systemColorScheme = useMedia("(prefers-color-scheme: dark)")
    ? "dark"
    : "light";

  let colorSchemeValue: "light" | "dark" = "light";

  if (theme === "system") {
    colorSchemeValue = systemColorScheme;
  } else {
    colorSchemeValue = theme;
  }

  useEffect(() => {
    const meta =
      document.querySelector("meta[name=color-scheme]") ??
      document.head.appendChild(document.createElement("meta"));
    meta.setAttribute("name", "color-scheme");
    meta.setAttribute("content", colorSchemeValue);
  }, [colorSchemeValue]);

  return (
    <ColorScheme value={colorSchemeValue}>
      <ColorSchemeContext.Provider value={{ theme, setTheme }}>
        {children}
      </ColorSchemeContext.Provider>
    </ColorScheme>
  );
};
